import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './style.pcss';
import { connect } from 'react-redux';

@connect((state) => ({
    localId  : state.progressBar.localId,
    isVisible: state.progressBar.isVisible
}))

class ProgressBar extends PureComponent {

    static displayName = '[block] progress-bar';

    render() {
        let result = null;

        if(this.props.componentId === this.props.localId && this.props.isVisible) {
            result = (
                <div className={style['tasks__progress']}>
                    <div className={style['tasks__progress-bar']} style={{ width: '100%' }}>
                        <span className={style['tasks__sr-only']} />
                    </div>
                </div>
            )
        }

        return result
    }

}

export default ProgressBar;

ProgressBar.propTypes = {
    componentId: PropTypes.number,
    isVisible  : PropTypes.bool,
    localId    : PropTypes.number
};

ProgressBar.defaultProps = {
    componentId: 0,
    isVisible  : false,
    localId    : 0
};



// WEBPACK FOOTER //
// ./src/blocks/progress-bar/index.js